import React from 'react';
import { cx } from './cx';

export interface SegmentOption<T extends string> {
  value: T;
  label: React.ReactNode;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  /** Accessible name for the group. */
  label: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/** Pick one of 2–12 short options that switch a mode or view (not for form values with many options). */
function SegmentedControl<T extends string>({ options, value, onChange, label, disabled, size = 'md', className }: SegmentedControlProps<T>) {
  return (
    <div className={cx('ds-segmented', size === 'sm' && 'ds-segmented--sm', className)} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="ds-segmented__option"
          aria-pressed={option.value === value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
